export default "__VITE_ASSET__07bb4b6c__"